module.exports = "<div class=\"footer\">\r\nfooter\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/markup/html/footing.html
 ** module id = 58
 ** module chunks = 0
 **/